import { chartColorsMixin } from "@/modules/global/mixins/chartColorsMixin.js";
import { mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      eChart: {
        data: null,
        extraOptions: null
      },
      baseChartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        responsive: true
      }
    };
  },
  mixins: [chartColorsMixin],
  computed: {
    ...mapState({
      time: state => state.globalStore.activeFilterParams.time
    }),
    timeFrame() {
      return this.getTimeFrame();
    },
    getDaysListInTimeframeUTC() {
      let days = [];
      let daysDiff = moment()
        .startOf("day")
        .diff(this.getTimeFrame(), "days");
      let timeFrameAgo = this.getTimeFrame();
      for (let i = 0; i <= daysDiff; i++) {
        let day = timeFrameAgo
          .add(1, "days")
          .startOf("day")
          .utc()
          .format();
        days.push(day);
      }
      return days;
    }
  },
  mounted() {
    this.LearnerEngagement();
  },
  methods: {
    LearnerEngagement() {
      //bucket specific days for matching results
      const bucketOne = this.getBucketDays(0);
      const bucketTwo = this.getBucketDays(8);
      const bucketThree = this.getBucketDays(17);

      //bucket tooltips & labels
      let labels = [[], [], []];
      Object.keys(bucketOne).forEach(date => {
        labels[0].push({ day: date });
      });
      Object.keys(bucketTwo).forEach(date => {
        labels[1].push({ day: date });
      });
      Object.keys(bucketThree).forEach(date => {
        labels[2].push({ day: date });
      });

      this.userData.forEach(user => {
        if (user.engagement) {
          user.engagement.dates.forEach(date => {
            let parsedDate = this.dateFromUtc(date._id);
            let label;
            if (bucketOne[parsedDate] > -1) {
              bucketOne[parsedDate] += date.t;
              label = labels[0].find(function(label) {
                return label.day == parsedDate;
              });
            } else if (bucketTwo[parsedDate] > -1) {
              bucketTwo[parsedDate] += date.t;
              label = labels[1].find(function(label) {
                return label.day == parsedDate;
              });
            } else if (bucketThree[parsedDate] > -1) {
              bucketThree[parsedDate] += date.t;
              label = labels[2].find(function(label) {
                return label.day == parsedDate;
              });
            } else {
              // eslint-disable-next-line no-console
              // console.log('NO Bucket Match: ' + parsedDate);
            }
            //add the label content
            if (label) {
              if (!label.learners) label.learners = [];
              label.learners.push({
                name: `${user.firstName} ${user.lastName}`,
                time: date.t
              });
            }
          });
        }
      });

      this.createBarChartEngage({
        bucketOne: Object.values(bucketOne),
        bucketTwo: Object.values(bucketTwo),
        bucketThree: Object.values(bucketThree),
        labels: labels,
        labelsUnique: true,
        xAxis: "Day",
        yAxis: "Time Spent on app total (minutes)",
        percentSign: false,
        chartType: 4,
        ticks: true
      });
    },
    IndividualLearnerEngagement(learnerId) {
      let user = this.userData.find(user => user._id === learnerId);
      if (!user) {
        user = this.reflectiveData.find(user => user._id === learnerId);
      }
      //bucket specific days for matching results
      const bucketOne = this.getBucketDays(0);
      const bucketTwo = this.getBucketDays(8);
      const bucketThree = this.getBucketDays(17);
      //get the chart labels
      let labels = [[]];
      Object.keys(bucketOne).forEach(date => {
        labels[0].push({ day: date });
      });
      //group engagements by bucket
      if (user.engagement) {
        user.engagement.dates.forEach(date => {
          let parsedDate = this.dateFromUtc(date._id);
          if (bucketOne[parsedDate] > -1) {
            bucketOne[parsedDate] += date.t;
          } else if (bucketTwo[parsedDate] > -1) {
            bucketTwo[parsedDate] += date.t;
          } else if (bucketThree[parsedDate] > -1) {
            bucketThree[parsedDate] += date.t;
          } else {
            // eslint-disable-next-line no-console
            // console.log('NO bucket match ' + parsedDate);
          }

          let label = labels[0].find(label => label.day == parsedDate);
          if (label) {
            label.time = date.t;
          }
        });
      }

      this.createBarChartEngage({
        bucketOne: Object.values(bucketOne),
        bucketTwo: Object.values(bucketTwo),
        bucketThree: Object.values(bucketThree),
        labels: labels,
        labelsUnique: false,
        xAxis: "Day",
        yAxis: "Time Spent on app total (minutes)",
        percentSign: false,
        chartType: 4,
        ticks: true
      });
    },
    iterateThroughLearnerEngagements(engagementsArray) {
      let count = 0;
      engagementsArray.forEach(engagement => {
        let s = moment(engagement.date).isSameOrAfter(this.timeFrame);
        if (s) {
          count = count + engagement.sum;
        }
      });
      return count;
    },
    createBarChartEngage(params) {
      let data = {
        datasets: [
          {
            backgroundColor: this.yellow,
            borderColor: "#666666",
            lineTension: 0.1,
            fill: false,
            pointHoverRadius: 4,
            data: params.bucketOne,
            labels: params.labels[0]
          },
          {
            backgroundColor: this.green,
            borderColor: "#666666",
            lineTension: 0.1,
            fill: false,
            pointHoverRadius: 4,
            data: params.bucketTwo,
            labels:
              params.labelsUnique === true ? params.labels[1] : params.labels[0]
          },
          {
            backgroundColor: this.red,
            borderColor: "#666666",
            lineTension: 0.1,
            fill: false,
            pointHoverRadius: 4,
            data: params.bucketThree,
            labels:
              params.labelsUnique === true ? params.labels[2] : params.labels[0]
          }
        ],
        labels: params.labels[0].map(label => this.dayDate(label.day))
      };
      let extraOptions = {
        ...this.baseChartOptions,
        scales: {
          yAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(29,140,248,0.0)"
              },
              scaleLabel: {
                display: true,
                labelString: params.yAxis,
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: true,
                beginAtZero: true,
                min: 0,
                fontColor: "#9a9a9a",
                callback: function(value) {
                  if (Number.isInteger(value)) {
                    return `${value}`;
                  }
                }
              }
            }
          ],

          xAxes: [
            {
              stacked: true,
              gridLines: {
                drawBorder: true,
                color: "rgba(225,78,202,0.1)"
              },
              scaleLabel: {
                display: true,
                labelString: params.xAxis,
                fontStyle: "bold",
                fontSize: "16"
              },
              ticks: {
                display: params.ticks ? true : false,
                fontColor: "#9a9a9a"
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            title: (tooltipItem, data) => {
              return this.labelTitle(
                data["datasets"][tooltipItem[0].datasetIndex]["labels"][
                  tooltipItem[0].index
                ],
                data["datasets"][tooltipItem[0].datasetIndex]["data"][
                  tooltipItem[0].index
                ],
                tooltipItem[0].datasetIndex //bucket indicator
              );
            },
            label: (tooltipItem, data) => {
              let labels = [];
              if (
                data["datasets"][tooltipItem.datasetIndex]["labels"][
                  tooltipItem.index
                ]["learners"]
              ) {
                data["datasets"][tooltipItem.datasetIndex]["labels"][
                  tooltipItem.index
                ]["learners"].forEach(learner => {
                  labels.push(learner.name + ": " + learner.time + " minutes");
                });
                return labels;
              }
            }
          }
        },
        hover: {
          onHover: function(e) {
            var point = this.getElementAtEvent(e);
            if (point.length) e.target.style.cursor = "pointer";
            else e.target.style.cursor = "default";
          }
        }
        //Disable on click until we know what to do with it
        // onClick: (event, item) => {
        //   if (item.length > 0) {
        //     let index = item[0]._index;
        //     this.engagementChartClicked(index, params.chartType);
        //     this.updateLearnerModal(true);
        //   }
        // }
      };
      this.eChart.data = { ...data };
      this.eChart.extraOptions = { ...extraOptions };
    },
    engagementChartClicked(index, chartType) {
      this.updateActiveLearner(this.userData[index]);
      this.updateActiveLearnerButton(chartType - 2);
    },
    dayDate(utcTime) {
      return moment(utcTime).format("dddd Do");
    },
    dateFromUtc(utc) {
      return moment(new Date(utc))
        .utc()
        .format();
    },
    labelTitle(labelsToolIndex, dataToolIndex, dataSetIndex) {
      if (labelsToolIndex.learners) {
        return (
          this.bucketNameTitle(dataSetIndex) +
          this.dayDate(labelsToolIndex.day) +
          ": " +
          labelsToolIndex.learners.length +
          (labelsToolIndex.learners.length > 1 ? " learners" : " learner") +
          " spent " +
          dataToolIndex +
          (dataToolIndex > 1 ? " mins" : " min") +
          " online"
        );
      } else {
        return (
          this.bucketNameTitle(dataSetIndex) +
          this.dayDate(labelsToolIndex.day) +
          ": Learner spent " +
          dataToolIndex +
          (dataToolIndex > 1 ? " mins" : " min") +
          " online"
        );
      }
    },
    getTimeFrame() {
      if (this.time === "day") {
        return moment()
          .startOf("day")
          .subtract(24, "hours")
          .utc();
      } else if (this.time === "week") {
        return moment()
          .startOf("day")
          .subtract(6, "days")
          .utc();
      } else if (this.time === "month") {
        return moment()
          .startOf("day")
          .subtract(1, "month")
          .utc();
      }
    },
    getBucketDays(bucketHour) {
      let days = [];
      let daysDiff = moment()
        .startOf("day")
        .diff(this.getTimeFrame(), "days");
      let timeFrameAgo = this.getTimeFrame();
      for (let i = 0; i <= daysDiff; i++) {
        let day = timeFrameAgo
          .add(1, "days")
          .startOf("day")
          .hours(bucketHour)
          .format();
        days.push(day);
      }
      return days.reduce((acc, curr) => ((acc[curr] = 0), acc), {});
    },
    bucketNameTitle(bucketNumber) {
      let bucketName = "";
      if (bucketNumber === 0) {
        bucketName += "Before 8AM on "; //Early Bird
      } else if (bucketNumber === 1) {
        bucketName += "Between 8AM-5PM on "; //Formal Horse
      } else if (bucketNumber === 2) {
        bucketName += "After 5PM on "; // Night Owl
      } else {
        bucketName += "Unknown time on ";
      }
      return bucketName;
    }
  },
  watch: {
    userData: {
      handler: function() {
        this.LearnerEngagement();
      }
    },
    time: {
      handler: function() {
        this.LearnerEngagement();
      }
    }
  }
};
